// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"06ef5754","286":"0a41d580","509":"15a992ec","525":"bd89a95b","607":"15a992ec"}[chunkId] + ".chunk.css";
};